export var PricingRuleType;
(function (PricingRuleType) {
    PricingRuleType["RANGE_BASED"] = "range_based";
    PricingRuleType["UP_TO"] = "up_to";
})(PricingRuleType || (PricingRuleType = {}));
export var DateType;
(function (DateType) {
    DateType["MONTHLY"] = "monthly";
    DateType["ACCUMULATIVE"] = "accumulative";
})(DateType || (DateType = {}));
export var PricingType;
(function (PricingType) {
    PricingType["UNITS"] = "units";
    PricingType["SPEND"] = "spend";
})(PricingType || (PricingType = {}));
//# sourceMappingURL=progressive-tiers.js.map